import { inject, Injectable, Injector, runInInjectionContext } from "@angular/core";
import { DocumentData, DocumentSnapshot, Firestore } from "@angular/fire/firestore";
import { AppDatabaseDefinitionService } from "./app-defintion.service";

@Injectable({
    providedIn: 'root',
  })
export class AppDatabaseService {
  private readonly db: Firestore = inject(Firestore);
  private readonly definition = inject(AppDatabaseDefinitionService);
  private readonly injector = inject(Injector);

  readLive(path: string, next: (data: DocumentSnapshot<DocumentData, DocumentData>) => void) {
    return runInInjectionContext(this.injector, () => {
      const docRef = this.definition.doc(this.db, path);
      
      const unsubscribe = this.definition.onSnapshot(
        docRef,
        (snapshot) => {
          next(snapshot);
        },
        (error) => {
          console.error(`[AppDatabaseService] Firestore snapshot error for path: ${path}`, error);
        }
      );
      
      return unsubscribe;
    });
  }

  readCollectionLive(path: string) {
    return runInInjectionContext(this.injector, () => {
      const collectionRef = this.definition.collection(this.db, path);
      return this.definition.collectionData(collectionRef);
    });
  }
}